"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const SvgDropDown = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ "data-testid": "ICON_DROP-DOWN", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M5 6a1 1 0 0 0-.707 1.707l3 3a1 1 0 0 0 1.414 0l3-3A1 1 0 0 0 11 6H5Z" }) })));
exports.default = SvgDropDown;
